module.exports = __webpack_public_path__ + "static/media/tire-finder-art.b5797ac4.png";